export enum ErrorTypeEnum {
  UndefinedError = 0,

  // adaptacion 1xx
  DefaultAdapter_JsonTransformException = 101,
  DefaultAdapter_GeneralException = 102,
  Adapter_RedirectException = 103,
  DefaultAdapter_NullParameterException = 104,
  Adapter_DocumentLinesRequired = 105,
  Adapter_DocumentLineExtensionAmount = 106,
  Adapter_DocumentTaxExclusiveAmount = 107,
  Adapter_DocumentTaxInclusiveAmount = 108,
  Adapter_InvalidParameterException = 109,


  // Cargue de datos 2xx
  CUFEGeneration_TechnicalKeyEmpty = 201,

  LoadData_TechnicalError = 202,
  LoadLegalData_DianResolutionNoExists = 203,
  LoadLegalData_DuplicatedDianResolutions = 204,
  LoadLegalData_SupplierInfoEmpty = 205,
  LoadLegalData_CertificateNoFound = 206,
  LoadLegalData_DocumentNull = 207,
  LoadData_TransformRequestEmptyTrackid = 208,
  LoadData_TransformRequestEmptyContent = 209,
  LoadData_TransformRequestEmptyRequest = 210,
  LoadData_TransformRequestJsonError = 211,
  LoadData_PreviousApprovedDocument = 212,
  LoadLegalData_ConsecutiveOutOfRange = 213,
  LoadLegalData_DateOutOfRange = 214,
  LoadData_PackagesWithoutBalance = 215,
  LoadData_PackagesReadError = 216,

  CUFEGeneration_SoftwarePinEmpty = 243,
  CUFEGeneration_SoftwareIdEmpty = 244,
  CUFEGeneration_SecurityCodeError = 245,
  CUFEGeneration_InvoiceCufeError = 246,
  CUFEGeneration_CreditNoteCufeError = 247,
  CUFEGeneration_DebitNoteCufeError = 248,
  CUFEGeneration_ContingenceCufeError = 249,

  // XMLGeneration 3xx
  XMLGeneration_GeneralError = 301,
  XMLGeneration_TechnicalError = 302,
  XMLGeneration_ConvertToXML = 303,
  XMLGeneration_RedirectException = 304,
  AttachedDocumentObjectCreationError = 305,
  AttachedDocumentDocumentTransformError = 306,

  // firma del documento 4xx
  LoadCert_Error = 401,
  LoadCert_ByPathError = 402,
  LoadCert_MemoryStreamNull = 403,
  LoadCert_ReadPasswordError = 404,
  Sign_NoTenantFound = 405,
  Sign_XMLSignException = 406,

  SignCall_GeneralError = 490,
  SignCall_ErrorResponse = 491,
  SignCall_DeserializationError = 492,
  SignCall_RequestNullOrEmpty = 493,

  // envio de documento 5xx
  SendDocument_TestSendGeneralError = 501,
  SendDocument_ProductionSendGeneralError = 502,
  SendDocument_ProductionTestSendGeneralError = 503,
  SendDocument_NoTenantFound = 504,

  SendCall_GeneralError = 590,
  SendCall_ErrorResponse = 591,
  SendCall_DeserializationError = 592,
  CheckZipKey_DeserializationError = 593,
  CheckZipKey_ErrorResponse = 594,
  CheckZipKey_GeneralError = 595,

  // errores retornados por la dian 6xx
  DianResponse_AsyncGenericError = 601,
  DianResponse_SyncGenericError = 602,
  DianResponse_DeserializationError = 603,
  DianResponse_RejectedGenericError = 604,

  // errores al registrar eventos de documentos 7xx
  SendEvent_GeneralError = 701,
  SendEvent_EmptyResult = 702,
  SendEvent_UnknowCodeResult = 703,
  SendEvent_PreviouslyRejected = 704,
  SendEvent_PreviouslyAccepted = 705,
  SendEvent_NotEventAllowed = 706,

  // Gestion certificados 90x
  SaveCertificate_DirectoryError = 901,
  SaveCertificate_CertFileWriteError = 902,
  SaveCertificate_PassFileWriteError = 903,
  SaveCertificate_NoTenantFound = 904,

  // Gestion resoluciones 92x
  SincResolutions_NoTenantFound = 921,
  SincResolutions_NoResolutionsAsociatedError = 922,
  SincResolutions_NoSuccessCallService = 923,

  // errores de envio de email 12xx
  Email_GeneralException = 1200,
  InvalidTargetEmail = 1201,
  InvalidSourceEmail = 1202,
  InvalidContent = 1203,
  EmptyTargetEmail = 1204,
  EmailTemplateLoadingError = 1205,
  Email_SupplierWithoutShippingEnable = 1206,
  Email_NoAttachFileFound = 1207,
  Email_NoEmailTargetsFound = 1208,
  Email_SupplierWithoutAutoShippingEnable = 1209,
  Email_SuccessDescription = 1210,
  Email_SendProcessError = 1211,

  // errores de Autenticacion / Autorizacion 13xx
  WrongUsernameOrPassword = 1301,
  AuthorizationStringEmptyOrNull = 1302,
  UnauthorizedAction = 1406,
  UserAlreadyExists = 1407,
  TenantAlreadyExists = 1408,
  InactiveUser = 1409,

  // errores validacion 14xx
  DatabaseErrorValidation = 1401,
  RequestErrorValidation = 1402,
  InvalidImageExtension = 1403,
  ObjectIsNull = 1404,
  StringIsNullOrEmpty = 1405,
  CompanyKeyNotFound = 1409,
  InvalidValue = 1410,

  // errores globales 15xx
  UnknownError = 1500,
  FileNotFound = 15001,
  KeyInListOfValuesNotFound = 15002,

  // errores en manejo de certificado digital 16xx
  NoActiveCertificateWasFound = 1601,
  ErrorSavingCertificate = 1602,
  CertificateAlreadyExist = 1603,
  ErrorReadingCertificate = 1604,

  // errores en gestion de representacion grafica  17xx
  GraphicRep_EmptyParametersOnLoadFile = 1701,
  GraphicRep_ErrorSavingFile = 1702,
  GraphicRep_ErrorParsing64baseToBytes = 1703,

  // errores en set de pruebas 18xx
  TestSet_NullParameters = 1800,
  TestSet_NoEnougthParameters = 1801,
  TestSet_BaseInvoiceNoFound = 1802,
  TestSet_SourceFromBaseInvoiceNoFound = 1803,
  TestSet_DeserializationError = 1804,

  //Descripciones de acciones
  RejectedByCustomer_Description = 23,
  RejectByUser_Description = 24,
}
